import Brand from "./Brand";

const Header = () => {
	return (
		<div className="m-6">
			<Brand />
		</div>
	);
};

export default Header;
